import BaseModel from "./BaseModel";
import CheckoutStatus from "./CheckoutStatus";
import {auth} from "../firebase";

export default class Checkout extends BaseModel {
    static data_name = 'checkouts';
    
    static newInstance(program_id) {
        let instance = new this();
        instance.is_process_complete = false;
        instance.has_successful_payment = false;
        instance.has_been_cancelled = false;
        instance.has_error = false;
        instance.member_id = "";
        instance.program_id = program_id;
        instance.first_name = "";
        instance.last_name = "";
        instance.email = auth.currentUser ? auth.currentUser.email : "";
        instance.created_at = this.timestamp();
        return instance;
    }
    
    async create(){
        this.created_at = this.constructor.timestamp();
        this.updated_at = this.constructor.timestamp();
        await this.save();
        await CheckoutStatus.newInstance(this).save();
    }
}